import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Features } from "./components/Features";
import { HowItWorks } from "./components/HowItWorks";
import { AppSelection } from "./components/AppSelection";
import { Pricing } from "./components/Pricing";
import { DownloadSection } from "./components/DownloadSection";
import { FAQ } from "./components/FAQ";
import { HighDemandNotice } from "./components/HighDemandNotice";
import { Footer } from "./components/Footer";
import { PrivacyPolicy } from "./components/PrivacyPolicy";
import { TermsOfService } from "./components/TermsOfService";
import { AdminUpload } from "./components/AdminUpload";
import { GoogleAnalytics } from "./utils/analytics";
import { InstallGuide } from "./components/InstallGuide";
import { AdminSettings } from "./components/AdminSettings";

// New components from gig-web-N2
import { Dashboard } from "./components/Dashboard";
import { Purchase } from "./components/Purchase";
import { PaymentSuccess } from "./components/PaymentSuccess";
import { DownloadApps } from "./components/DownloadApps";

const HomePage = () => (
  <>
    <Hero />
    <Features />
    <HowItWorks />
    <AppSelection />
    <Pricing />
    <DownloadSection />
    <FAQ />
    <HighDemandNotice />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <GoogleAnalytics />
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/como-instalar" element={<InstallGuide />} />
            <Route path="/how-to-install" element={<InstallGuide />} />
            <Route path="/como-instalar-pt" element={<InstallGuide />} />
            <Route path="/admin/upload" element={<AdminUpload />} />
            <Route path="/admin/settings" element={<AdminSettings />} />
            {/* New routes from gig-web-N2 */}
            <Route path="/purchase/:appName" element={<Purchase />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/dashboard/:appName" element={<Dashboard />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
